import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Typography } from '@material-ui/core';
import AddProductIcon from '../../assets/icons/home/add-icon.svg';
import ShareIcon from '../../assets/icons/share-icon.svg';
import WhatsappIcon from '../../assets/icons/home/whatsapp-icon.svg';
import ClientIcon from '../../assets/icons/home/add-client-icon.svg';

// Internal dependencies
import { routes } from '../../constants.js/misc';
import { setStoreData } from '../../modules/common';
import { setActiveCollection } from '../../modules/collections';
import { getProductsServiceMobile } from '../../services/products';
import { drawerStyles } from '../../containers/AppContainer/AppContainer.styles';
import {
    HomePageMobileCardContainer,
    HomePageMobileCardIcon,
    HomePageMobileContainer,
    HomePageMobileOrderButton,
} from './HomePage.styles';
import PreviewLinkStore from '../../components/PreviewLinkStore/PreviewLinkStore';
import { colors } from '../../constants.js/colors';
import { functionalPlusIcon as PlusIcon } from '../../assets/icons/functional-plus-icon';
import AlertFreemiumPlan from '../../components/AlertFreemiumPlan';
import { useSnackbar } from 'notistack';

export const HomePageMobileNewUsers = ({ storeId, storeData }) => {
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const [dataProducts, setDataProducts] = useState([]);
    const [getttingProduct, setGettingProduct] = useState();

    const [statusPlan, setStatusplan] = useState(null);
    const [daysToPay, setDaysToPay] = useState(null);
    const [paymentStatus, setPaymentStatus] = useState(null);
    const [isPreviewLinkOpen, setIsPreviewLinkOpen] = useState(false);

    const isFreemiumPlan = storeData?.store_plan.plan.name.toLowerCase() === 'freemium';

    const openPreviewLink = () => {
        setIsPreviewLinkOpen(true);
    };

    useEffect(() => {
        setGettingProduct(true);
        getProductsServiceMobile(storeId).then(({ data }) => {
            setGettingProduct(false);
            setDataProducts(data);
        });
    }, [storeId]);

    useEffect(() => {
        if (storeData) {
            if (storeData.store_plan) {
                setStatusplan(storeData.store_plan.store_plan_status_id);
                setDaysToPay(storeData.store_plan.days_to_pay);
                setPaymentStatus(storeData.store_plan.store_plan_payment_status_id);
            }
        }
    }, [storeData]);

    return (
        <HomePageMobileContainer>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <Typography variant="h5" style={{ color: colors.secondary.main }}>
                    Hola, {storeData.name} 👋 ¡Bienvenida a Ecometri!
                </Typography>
                {isFreemiumPlan && <AlertFreemiumPlan />}
            </div>

            <iframe
                width="300"
                height="300"
                src="https://www.youtube-nocookie.com/embed/oWInN0iyz70?rel=0&modestbranding=1"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            />

            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '8px',
                    width: '100%',
                }}
            >
                <Typography
                    variant="subtitle2"
                    style={{ fontWeight: 400, color: '#4A4A4A', textDecoration: 'underline' }}
                >
                    ¿Cómo funciona Ecometri?
                </Typography>
                <Link
                    to={routes.createProduct}
                    onClick={(e) => {
                        if (
                            typeof window !== 'undefined' &&
                            window.sessionStorage.getItem('freemium-block-add-products') === '1'
                        ) {
                            e.preventDefault();
                            enqueueSnackbar(
                                'Tu plan Freemium permite hasta 20 productos. Mejora tu plan para agregar más.',
                                { variant: 'info', autoHideDuration: 4000 }
                            );
                        }
                    }}
                    style={{
                        textDecoration: 'none',
                        color: 'inherit',
                        width: '100%',
                    }}
                >
                    <HomePageMobileOrderButton
                        fullWidth
                        startIcon={<PlusIcon />}
                        style={{
                            fontSize: '16px',
                            fontWeight: 700,
                        }}
                    >
                        Subí tu primer producto
                    </HomePageMobileOrderButton>
                </Link>
                <Typography variant="subtitle2" style={{ fontWeight: 400, color: '#4A4A4A' }}>
                    Solo toma 1 minuto. Puedes editarlo más tarde.
                </Typography>
            </div>

            {/* <div
                style={{
                    display: 'flex',
                    padding: '16px',
                    borderRadius: '16px',
                    background: '#F0FEF9',
                    flexDirection: 'column',
                    width: '100%',
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div
                        style={{
                            width: '12px',
                            height: '12px',
                            borderRadius: '100%',
                            background: colors.primary.main,
                        }}
                    ></div>
                    <Typography
                        variant="subtitle1"
                        style={{ color: colors.primary.dark, fontWeight: 500 }}
                    >
                        Prueba activa: 7 días restantes
                    </Typography>
                </div>
                <Typography variant="body1">Sin comisiones. Sin tarjeta. Todo para vos.</Typography>
            </div> */}

            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
                    gap: '16px',
                    width: '100%',
                }}
            >
                <Link
                    to={routes.clientPage}
                    style={{ textDecoration: 'none', color: 'inherit', display: 'flex' }}
                >
                    <HomePageMobileCardContainer
                        style={{
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '8px',
                        }}
                    >
                        <HomePageMobileCardIcon>
                            <img src={ClientIcon} alt="icon" />
                        </HomePageMobileCardIcon>
                        <Typography variant="body2">{t('ClientPage.addClient')}</Typography>
                    </HomePageMobileCardContainer>
                </Link>
                <button
                    style={{
                        background: 'none',
                        outline: 'none',
                        border: 'none',
                        width: '100%',
                        display: 'flex',
                        padding: 0,
                    }}
                    onClick={openPreviewLink}
                >
                    <HomePageMobileCardContainer
                        style={{
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '8px',
                        }}
                    >
                        <HomePageMobileCardIcon>
                            <img src={ShareIcon} />
                        </HomePageMobileCardIcon>
                        <Typography variant="body2">{t('MobileHomepage.share')}</Typography>
                    </HomePageMobileCardContainer>
                </button>
                <Link
                    to={routes.createOrder}
                    style={{ textDecoration: 'none', color: 'inherit', display: 'flex' }}
                >
                    <HomePageMobileCardContainer
                        style={{
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '8px',
                        }}
                    >
                        <HomePageMobileCardIcon>
                            <img src={AddProductIcon} />
                        </HomePageMobileCardIcon>
                        <Typography variant="body2">{t('Order.create')}</Typography>
                    </HomePageMobileCardContainer>
                </Link>
                <Link
                    to={routes.userStores}
                    style={{ textDecoration: 'none', color: 'inherit', display: 'flex' }}
                >
                    <HomePageMobileCardContainer
                        style={{
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '8px',
                        }}
                    >
                        <HomePageMobileCardIcon>
                            <img src={WhatsappIcon} />
                        </HomePageMobileCardIcon>
                        <Typography variant="body2">Configurar WhatsApp</Typography>
                    </HomePageMobileCardContainer>
                </Link>
            </div>

            <div style={{ width: '100%', textAlign: 'center' }}>
                <Typography variant="subtitle1">
                    👣 Tu tienda no es solo moda. Es un negocio. ¡Empezá ahora!
                </Typography>
            </div>
            <PreviewLinkStore
                open={isPreviewLinkOpen}
                dataStore={storeData}
                storeId={storeData.id}
                onClose={() => setIsPreviewLinkOpen(false)}
                title={t('PreviewLink.title')}
                message={t('PreviewLink.subtitle')}
            />
        </HomePageMobileContainer>
    );
};

const mapStateToProps = ({ auth, common, collections }) => ({
    storeId: auth.storeId,
    storeData: common.storeData,
    activeCollection: collections.activeCollection,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setStoreData,
            setActiveCollection,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(HomePageMobileNewUsers);
